import { z } from 'zod'

export const MEMBERSHIP_SCIM_MAPPING_WRITE_CONTRACT_VERSION = '1.0.0' as const

export const membershipScimMappingWriteResponseSchema = z.record(z.unknown())

export type MembershipScimMappingWriteResponse = z.infer<typeof membershipScimMappingWriteResponseSchema>
